"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectOf = void 0;
const empty = {};
function objectOf(value, key) {
    if (value === undefined)
        return empty;
    return { [key]: value };
}
exports.objectOf = objectOf;
